import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { mainURL } from '../utils/common';
import { LeftSocialMediaIconUI } from '../components/LeftSocialMediaIconUI';
import { DownloadFileByFileStoreId } from '../components/DownloadFileByFileStoreId';

const Mpnld  = () => {
  const { t, i18n, ready } = useTranslation();

  return (
<>
  <section id="hero" className="hero hero2">
  <LeftSocialMediaIconUI />
    
    <div className="carousel-item active">
      <img src="assets/img/inner-bg2.png" className="img-fluid" alt />
      <div className="container"> <div className="section-main-heading2"></div></div>             
    </div>       	 		 
  </section>	  
  {/* End Slider */}
 
  <section className="section inner-pad1">
    <div className="container " >
      <div className="row">
        <div className="col-lg-3">
        <div className="site-menu  ">           
              <nav className="sidebar card py-2">
                <ul className="nav flex-column" id="nav_accordion">
                  <li className="nav-item"><Link className="nav-link fontSizeClass active1" to='/Mpnld'> {t("MPLAD")} </Link> </li>
                  <li className="nav-item"><Link className="nav-link fontSizeClass" to='/Beup'> {t("BEUP")} </Link></li>
                </ul>
              </nav>	   
            </div>
        </div>
        <div className="col-lg-9">
          <div className="container">
            <div className="row">
              <div className="inner-title"><h3 className="fontSizeClass">{t("MP Local Area Development Schemes")}</h3></div>
                <div id="accordion" className='col-lg-12'>
                <p className='font-siz1'>Click the links below to find out the details and progress of work for various projects taken under the MPLAD Scheme.</p>
                <p>
                  <DownloadFileByFileStoreId fileStoreId="" label="Status of MPLADS for sitting MPs, 2015"  />  {/* (File Not Avalable) */}
                   <a className="dropdown-item" href={`${mainURL}/citizen/language-selection`}> {t("More Details on Schemes")} </a>
                   </p>        
                </div>
            </div> 
          </div>
        </div>

        

      </div>
    </div>
    {/*   */}
  </section>
  
    </>
  )
}

export default Mpnld